import type sv from '../sv'
import common from './common'
import chat from './chat'
import documents from './documents'
import editor from './editor'
import tasks from './tasks'
import meetings from './meetings'
import settings from './settings'
import auth from './auth'
import notifications from './notifications'
import inbox from './inbox'
import meet from './meet'

const en: typeof sv = {
  common,
  chat,
  documents,
  editor,
  tasks,
  meetings,
  settings,
  auth,
  notifications,
  inbox,
  meet,
}

export default en
